import { useQuery } from "@tanstack/react-query";
import { environmentsApi } from "../api/environments";

const keys = {
  all: ["environments"] as const,
  list: () => [...keys.all, "list"] as const,
  listByApp: (app: string) => [...keys.all, "list", app] as const,
  detail: (app: string, envName: string) => [...keys.all, "detail", app, envName] as const,
  workloads: (app: string, envName: string) =>
    [...keys.all, "workloads", app, envName] as const,
};

export function useEnvironments() {
  return useQuery({
    queryKey: keys.list(),
    queryFn: () => environmentsApi.list(),
    refetchInterval: 30_000,
  });
}

export function useEnvironmentsByApp(app: string | undefined) {
  return useQuery({
    queryKey: keys.listByApp(app ?? ""),
    queryFn: () => environmentsApi.listByApp(app as string),
    enabled: !!app,
    refetchInterval: 30_000,
  });
}

export function useEnvironmentDetail(app: string | undefined, envName: string | undefined) {
  return useQuery({
    queryKey: keys.detail(app ?? "", envName ?? ""),
    queryFn: () => environmentsApi.get(app as string, envName as string),
    enabled: !!app && !!envName,
    refetchInterval: 15_000,
  });
}

export function useEnvironmentWorkloads(app: string | undefined, envName: string | undefined) {
  return useQuery({
    queryKey: keys.workloads(app ?? "", envName ?? ""),
    queryFn: () => environmentsApi.workloads(app as string, envName as string),
    enabled: !!app && !!envName,
    refetchInterval: 10_000,
  });
}
